export function authRequest (state) {
  state.authStatus = 'loading';
}

export function authSuccess (state) {
  state.authStatus = 'success';
}

export function authError (state) {
  state.authStatus = 'error';
}

export function setUser (state, value) {
  state.isLoggedIn = true;
  state.user = value;
}

export function setUserType (state, value) {
  state.user.isExternal = !value;
}

export function clearDataUser (state) {
  state.user = {};
  state.isLoggedIn = false;
  state.authStatus = '';
}

export function setUserAppsAuthorized (state, value) {
  state.user.appAuthorized = value;
}

export function setCiudadSelected (state, value) {
  state.CiudadSelected = value;
}

export function emptyCiudadSelected (state) {
  state.CiudadSelected = null;
}

export function setImgObjetivoEstrategico (state, value) {
  state.imgObjetivoEstrategico = value;
}
export function setObjetivoEspecifico (state, value) {
  state.objetivoEspecifico.name = value.name;
  state.objetivoEspecifico.id = value.id;
}
export function setNameIndicador (state, value) {
  state.nameIndicador = value;
}

export function setIdMunicipio (state, value) {
  state.idMunicipio = value;
}

export function setPublicMode (state, value) {
  state.publicMode = value;
}
